import { openApi } from '@/api/request'
export default {
    /**
     * 验证能否使用核销券
     * @param requestData
     * TikTokCampaignCode-活动码 | string
     * CruiseId-航线id | integer
     * UserName-用户token | string
     * @returns {*}
     */
    checkCanApplyByCampaignCode(requestData) {
        const url = `/Rccl.OpenApi/TikTokCampaign/CheckCanApplyByCampaignCode`
        return openApi.post(url, requestData)
    },
    /**
     * 验证核销券是否有效
     * @param requestData
     * TikTokCampaignCode-活动码 | string
     * TikTokCouponCode-核销券码 | string
     * CruiseId-航线id | integer
     * UserName-用户token | string
     * @returns {*}
     */
    checkCanApplyByCouponCode(requestData) {
        const url = `/Rccl.OpenApi/TikTokCampaign/CheckCanApplyByCouponCode`
        return openApi.post(url, requestData)
    }
}
